module.exports = __webpack_public_path__ + "img/RTK-base-station.d40927a.png";